import React from 'react';
export function Footer() {
  return <footer className="bg-cream py-12 border-t border-mint/20" data-id="element-31">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-32">
        <div className="flex items-center gap-2 mb-8" data-id="element-33">
          <div className="w-6 h-6 rounded-full bg-mint flex items-center justify-center text-white font-serif font-bold text-xs" data-id="element-34">
            T
          </div>
          <span className="font-serif font-bold text-xl text-dark" data-id="element-35">
            Tricotín Rentable
          </span>
        </div>

        <nav className="flex flex-wrap justify-center gap-6 mb-8" data-id="element-36">
          <a href="#" className="text-muted hover:text-mint transition-colors font-medium" data-id="element-37">
            Inicio
          </a>
          <a href="#oferta" className="text-muted hover:text-mint transition-colors font-medium" data-id="element-38">
            Oferta
          </a>
          <a href="#" className="text-muted hover:text-mint transition-colors font-medium" data-id="element-39">
            Testimonios
          </a>
          <a href="#" className="text-muted hover:text-mint transition-colors font-medium" data-id="element-40">
            Contacto
          </a>
        </nav>

        <p className="text-sm text-muted text-center" data-id="element-41">
          © {new Date().getFullYear()} Tricotín Rentable. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}